import React from 'react';

interface TabletLayoutProps {
  children: React.ReactNode;
  overflow?: 'hidden' | 'auto';
}

export default function TabletLayout({ children, overflow = 'hidden' }: TabletLayoutProps) {
  return (
    <>
      {/* Landscape warning for small/portrait screens */}
      <div className="landscape-warning">
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔄</div>
          <div>Veuillez utiliser une tablette en mode paysage.</div>
          <div style={{ fontSize: '16px', marginTop: '8px', opacity: 0.7 }}>
            Largeur minimale requise : 900 pixels
          </div>
        </div>
      </div>

      {/* Main tablet container */}
      <div
        className="tablet-root"
        style={{
          overflow: overflow === 'hidden' ? 'hidden' : 'auto',
          display: 'flex',
          flexDirection: 'column',
          paddingLeft: 'max(0px, env(safe-area-inset-left))',
          paddingRight: 'max(0px, env(safe-area-inset-right))',
          paddingBottom: 'max(0px, env(safe-area-inset-bottom))',
        }}
      >
        {children}
      </div>
    </>
  );
}